import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=67e5940d&scoped=true&"
import script from "./PublicLayout.vue?vue&type=script&lang=js&"
export * from "./PublicLayout.vue?vue&type=script&lang=js&"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&id=67e5940d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e5940d",
  null
  
)

export default component.exports